import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule)
  },
  {
    path: 'validate-certificate/:code',
    loadChildren: () => import('./pages/final-certificate/validate-certificate/final-certificate.module').then(m => m.FinalCertificateModule)
  },
  {
    path: 'about-certificate/:code',
    loadChildren: () => import('./pages/final-certificate/about-certificate/about-certificate.module').then(m => m.AboutCertificateModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'login/:user_mail',
    loadChildren: () => import('./pages/login/impersonate-login/impersonate-login.module').then( m => m.ImpersonateLoginPageModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./pages/login/register/register.module').then( m => m.RegisterPageModule)
  },
  {
    path: 'checkout',
    redirectTo: '/home',
  },
  {
    path: 'certificado/:code',
    loadChildren: () => import('./pages/journey/certificate/certificate.module').then( m => m.CertificatePageModule)
  },
  {
    path: 'video-rating',
    loadChildren: () => import('./pages/video/video-rating/video-rating.module').then( m => m.VideoRatingPageModule)
  }
  
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
